import React, { useState, useEffect } from "react"
import {
  formatButton,
  formatDetails,
  setOverlayCookie,
  checkOverlayCookie,
} from "./OverlayNoticeMethods"
import useCheckOneTrust from "../../utils/hooks/useCheckOneTrust"
import Cookies from "js-cookie"
import { OverlayNotice } from "terra-one"

const OverlayNoticeConnector = ({ overlayNotice, location, locale }) => {
  const {
    updatedAt,
    redisplayDuration,
    header,
    richTextDetails,
    ctaButton,
    contentfulId,
  } = overlayNotice

  //Region: State and cookies
  const [hasDismissedOverlay, setHasDismissedOverlay] = useState(false)
  const { hasAcceptedOneTrust } = useCheckOneTrust(Cookies)

  // bypass oneTrust (i.e. force "accepted" state) if disable env var set
  const oneTrustAcceptedOrBypassed = process.env.GATSBY_DISABLE_ONETRUST === "true" ? true : hasAcceptedOneTrust;

  useEffect(() => {
    //Check if we have the appropriate cookie ...
    if (checkOverlayCookie(Cookies, updatedAt)) {
      //... if so, set hasDismissedOverlay to true
      setHasDismissedOverlay(true)
    }
  }, [updatedAt])

  const handleDismiss = () => {
    //When the user dismisses the overlay, set a cookie ...
    //so that we can check if the user has dismissed the overlay on future visits
    setOverlayCookie(Cookies, updatedAt, redisplayDuration)
    setHasDismissedOverlay(true)
  }

  //End Region: State and cookies

  //Region: Format content

  const { headline } = header || {}
  const { ctaButtons } = ctaButton || {}
  const formattedButton = ctaButtons ? formatButton({ buttons: ctaButtons, locale }) : null;
  const formattedDetails = formatDetails(richTextDetails, location)

  return (
    (hasDismissedOverlay === false) && (
      <OverlayNotice
        header={headline}
        button={formattedButton}
        details={formattedDetails}
        handleClose={handleDismiss}
        hasAcceptedOneTrust={oneTrustAcceptedOrBypassed}
        hasDismissedOverlay={hasDismissedOverlay}
        contentfulId={contentfulId}
      />
    )
  )
}

export default OverlayNoticeConnector
